var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myths-page"},[_c('div',{staticClass:"uk-section"},[_c('div',{staticClass:"uk-container uk-container-large"},[_c('h2',{staticClass:"myths-page__title"},[_vm._v(_vm._s(_vm.$t("message['Myths']")))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }